export const isEnglish = (value?: string) => {
  const VALID_SPECIAL_SYMBOLS = [
    '!',
    '#',
    '$',
    '%',
    '&',
    '*',
    '+',
    '-',
    '/',
    '?',
    '^',
    '_',
    '{',
    '|',
    '}',
    ',',
    '-',
    '~',
    '.',
    ' ',
  ];
  if (!value) {
    return false;
  }

  for (let i = 0; i < value?.length; i++) {
    const currentChar = value[i];
    const code = currentChar.charCodeAt(0);
    if (
      (code >= 1536 && code <= 1791) ||
      (VALID_SPECIAL_SYMBOLS.includes(currentChar) && code !== 32)
    ) {
      return false;
    }
  }
  return true;
};
